import { useState } from "react";

const PAGINATION_DEFAULT = {
  paging_size: 10,
  paging_index: 1,
  enable_paging: true,
};

export const usePagination = (initialPagination = PAGINATION_DEFAULT) => {
  const [pagination, setPagination] = useState(initialPagination);
  const [itemsCounter, setItemsCounter] = useState(0);

  const changePage = (newPage) => setPagination({ ...pagination, paging_index: newPage });
  const changeSize = (newSize) => setPagination({ ...pagination, paging_size: newSize });
  const setItemsCount = (count) => setItemsCounter(count);

  return {
    pagination,
    setPagination,
    itemsCounter,
    setItemsCount,
    changePage,
    changeSize,
  };
};
